module.exports = __webpack_public_path__ + "static/media/LackConcentartion.192227ac.png";